module.exports = __webpack_public_path__ + "img/persons-group.81828f23.png";